import type { VerbTypes } from 'modules/core/lib/verbTypes'

import type { FormType } from 'modules/surveys/store/models/Form'
import Form from 'modules/surveys/store/models/Form'

type VerbOption = Record<string, VerbTypes>
type Options = Record<string, VerbOption>

export const getPermissionVerbs = (formType: FormType): Options => {
  const surveyVerbs: Options = {
    forms: {
      permission: 'apiCore.accessSurveysCreateForms',
      owned: 'surveys.surveyCreateOwned',
      everybody: 'surveys.surveyCreateEverybody',
      reportees: 'surveys.surveyCreateReportees',
      team: 'surveys.surveyCreateTeam',
    },
    templates: {
      permission: 'apiCore.accessSurveysCreateTemplates',
    },
  }

  const reviewVerbs: Options = {
    forms: {
      permission: 'apiCore.accessReviewsCreateForms',
      owned: 'reviews.formCreateSelf',
      everybody: 'reviews.formCreateEverybody',
      reportees: 'reviews.formCreateReportees',
      team: 'reviews.formCreateTeam',
    },
    templates: {
      permission: 'apiCore.accessReviewsCreateTemplates',
    },
  }

  switch (formType) {
    case Form.Types.survey:
      return surveyVerbs

    case Form.Types.review:
      return reviewVerbs

    default:
      throw new Error(`Invalid form type ${formType}`)
  }
}
